/*
* Project: LegalPlace assistant
* File: src/redux/actions/app_state.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

const LP_STATE_WIZARD = 0;
const LP_STATE_CHECKOUT = 1;
const LP_STATE_PAYMENT = 2;
const LP_STATE_SAVE = 3;
const LP_STATE_PRE_WIZARD = 4;


const SET_STATE = 'SET_STATE';
const BACK_STATE = 'BACK_STATE';
const NEXT_STATE = 'NEXT_STATE';

function setAppState(appState, ignoreHistory = false) {
  return {
    type: SET_STATE,
    state: appState,
    ignoreHistory: ignoreHistory
  };
}
export {
  LP_STATE_WIZARD,
  LP_STATE_CHECKOUT,
  LP_STATE_PAYMENT,
  LP_STATE_SAVE,
  LP_STATE_PRE_WIZARD,
  SET_STATE,
  BACK_STATE,
  NEXT_STATE,
  setAppState,
};



// WEBPACK FOOTER //
// ./src/redux/actions/app_state.js